import { AuditInstructionWithDetailsModel } from '@alcon-db-models/AuditInstructionWithDetailsModel';
import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';

@Injectable({
  providedIn: 'root'
})
export class AuditInstructionWithDetailsService extends EntityCollectionServiceBase<AuditInstructionWithDetailsModel> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('AuditInstructionWithDetails', serviceElementsFactory);
  }
}


